/**
* @file 营销管理-轮播广告
* */
<template>
  <div id="couponReceiving">
    <custom-table
      ref="customTable"
      :customOptions="customOptions"
      :columns="columns"
      :showOrganization="true"
      
      addText=""
    >
      <template slot="search-top-left">
        <div class="condition">
          <el-select
            v-if="mixinUserInfo.organizationType === 1"
            v-model="customOptions.params.organizationId"
            placeholder="请选择机构名称"
            @change="sortFn"
            filterable
            clearable
          >
            <el-option
              v-for="val in organizations"
              :key="val.id"
              :value="val.id"
              :label="val.name"
            >
            </el-option>
          </el-select>
          <span style="line-height: 28px; margin-right: 0">状态：</span>
          <el-radio-group
            v-model="customOptions.params.status"
            @change="sortFn"
          >
            <el-radio-button label="">全部</el-radio-button>
            <el-radio-button
              :label="item.value"
              v-for="item in $const.COUPONRECORDSTATUS"
              :key="item.value"
              >{{ item.label }}
            </el-radio-button>
          </el-radio-group>
        </div>
      </template>
      <!-- <template slot="search-top-left">
        <el-radio-group
          v-model="customOptions.params.status"
          @change="sortFn"
        >
          <el-radio-button label="">全部</el-radio-button>
          <el-radio-button
            :label="item.value"
            v-for="item in $const.COUPONRECORDSTATUS"
            :key="item.value"
            >{{ item.label }}
          </el-radio-button>
        </el-radio-group>
      </template> -->
      <template slot-scope="{ item, row }">
        <template
          v-if="
            item.prop === 'created' ||
            item.prop === 'expirationDay' ||
            item.prop === 'usageTime'
          "
          >{{ row[item.prop] | filterTime }}</template
        >
        <template v-else-if="item.prop === 'status'">
          <span
            :class="row[item.prop] | filterConst('COUPONRECORDSTATUS', 'class')"
            >{{ row[item.prop] | filterConst("COUPONRECORDSTATUS") }}</span
          >
        </template>
        <template v-else>{{ row[item.prop] ? row[item.prop] : "-" }}</template>
      </template>
    </custom-table>
  </div>
</template>

<script>
export default { 
  name: "couponReceiving",
  data() {
    return {
      // 配置项
      customOptions: {
        // 请求的列表url
        url: "/api/v1/manage/coupon/record",
        params: {
          status: "",
          page: 1, // 页数
          size: 20, // 每页条数
        },
      },
      // 表头
      columns: [
        { prop: "customerPhone", label: "用户电话" },
        { prop: "couponName", label: "优惠券名称" },
        { prop: "couponExplanation", label: "优惠卷说明" },
        { prop: "status", label: "状态" },
        { prop: "created", label: "领取时间" },
        { prop: "expirationDay", label: "失效时间" },
        { prop: "usageTime", label: "使用时间" },
      ],
    };
  },
  methods: {
    /**
     * 状态改变
     */
    sortFn() {
      this.customOptions.params.page = 1;
      this.$refs.customTable.listFn();
    },
  },
  created() {
    this.mixinOrganizations();
  },
};
</script>

<style lang="less">
#couponReceiving {
  .condition {
    & > * {
      vertical-align: top;
      margin-right: 30px;
    }
  }
}
</style>
